import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'PlugXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-plug-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M13.55 17.733a5.806 5.806 0 0 1 -7.356 -4.052a5.81 5.81 0 0 1 1.537 -5.627l2.054 -2.054l7.165 7.165"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M4 20l3.5 -3.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M15 4l-3.5 3.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M20 9l-3.5 3.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M16 16l4 4"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M20 16l-4 4"
    }, null), _createTextVNode(" ")]);
  }
};